import Box from '@mui/material/Box'
import { useRoutes, type AppDispatch } from '../../../store'
import { AdPod } from 'common/api/v1/types'
import { ActionMenu as BaseActionMenu } from '../../common/Table/ActionMenu'
import SettingsIcon from '@mui/icons-material/Settings'
import DeleteIcon from '@mui/icons-material/Delete'
import { useConfirmationDialog } from '../../common/ConfirmDialog'
import { deleteAdPod } from '../../../redux/actions/adPodActions'

interface ActionMenuProps {
  adPod: AdPod
  dispatch: AppDispatch
}

export const ActionMenu = ({ adPod, dispatch }: ActionMenuProps) => {
  const routes = useRoutes()
  const { showConfirmation } = useConfirmationDialog()

  return (
    <Box sx={{ display: 'flex' }}>
      <BaseActionMenu
        data-test-id="input-action-menu"
        options={[
          {
            icon: <SettingsIcon />,
            label: 'Edit',
            href: routes.adPodsUpdate({ id: adPod.id }),
            openInNewTab: false,
          },
          {
            icon: <DeleteIcon />,
            label: 'Remove',
            isDestructive: true,
            onClick: () => {
              showConfirmation(
                () => dispatch(deleteAdPod(adPod.id)),
                'Are you sure you want to remove this ad creative?',
              )
            },
          },
        ]}
      />
    </Box>
  )
}
